import * as React from 'react'
import type {PreloadedQuery} from 'react-relay'

import {useVisibility} from '../../../../common/Visible/Visible.hooks'
import type {AgentsPagesPoolsAuthorizePermissionsQuery} from '../../__generated__/AgentsPagesPoolsAuthorizePermissionsQuery.graphql'
import type {AgentsTreeAgentNode} from '../../AgentsSidebar/AgentsSidebar.types'
import AgentFetcher from '../../components/AgentFetcher/AgentFetcher'
import {useCanAuthorizeInPools} from '../../components/AgentListView/AuthorizeAgent/AuthorizeAgent.hooks'
import UnauthorizedAgentListView from '../../components/AgentListView/UnauthorizedAgentListView'
import UnauthorizedAgentPlaceholderListView from '../../components/AgentListView/UnauthorizedAgentPlaceholderListView'

function VisibleUnauthorizedAgentContainer({
  agentNode,
  poolsAuthorizePermissionsQueryRef,
}: {
  agentNode: AgentsTreeAgentNode
  poolsAuthorizePermissionsQueryRef: PreloadedQuery<AgentsPagesPoolsAuthorizePermissionsQuery>
}) {
  const {isAgentLeft, canAuthorizeInPools} = useCanAuthorizeInPools(
    poolsAuthorizePermissionsQueryRef,
    agentNode.poolId,
  )

  return (
    <AgentFetcher agentId={agentNode.id}>
      {({agent}) => {
        if (agent != null) {
          return (
            <UnauthorizedAgentListView
              agent={agent}
              isAgentLeft={isAgentLeft}
              authorizableInPools={canAuthorizeInPools}
            />
          )
        }

        return <UnauthorizedAgentPlaceholderListView {...agentNode} />
      }}
    </AgentFetcher>
  )
}

function VisibleUnauthorizedAgent({
  className,
  poolsAuthorizePermissionsQueryRef,
  ...agentNode
}: AgentsTreeAgentNode & {
  className: string
  poolsAuthorizePermissionsQueryRef: PreloadedQuery<AgentsPagesPoolsAuthorizePermissionsQuery>
}) {
  const ref = React.useRef(null)
  const isVisible = useVisibility(ref)
  return (
    <div className={className} ref={ref}>
      {isVisible ? (
        <VisibleUnauthorizedAgentContainer
          agentNode={agentNode}
          poolsAuthorizePermissionsQueryRef={poolsAuthorizePermissionsQueryRef}
        />
      ) : (
        <UnauthorizedAgentPlaceholderListView {...agentNode} />
      )}
    </div>
  )
}

export default React.memo(VisibleUnauthorizedAgent)
